export default function initPopup() {
    const popupTriggerElems = document.querySelectorAll('[toggle-popup]');

    popupTriggerElems.forEach((elem) => {
        const targetElem = document.querySelector(`.chef-block-popup-wrapper-${elem.getAttribute('popup-id')}`);
        function toggleTarget() {
            if (targetElem.getAttribute('aria-hidden') === 'true') {
                elem.setAttribute('aria-expanded', 'true');
                targetElem.setAttribute('aria-hidden', 'false');
            } else {
                elem.setAttribute('aria-expanded', 'false');
                targetElem.setAttribute('aria-hidden', 'true');
            }
        }

        elem.addEventListener('click', (e) => {
            e.stopPropagation();
            e.preventDefault();
            toggleTarget();
        });
    });
}
